// src/pages/Pizza/PizzaDetails.js
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useApi } from '../../hooks/useApi';
import Header from "../../components/Form/Header";
import MainContent from "../../components/Form/MainContent";
import Footer from "../../components/Form/Footer";
import { FaTimes, FaCartPlus } from 'react-icons/fa';
import './PizzaDetails.css';
import { useCart } from "../../contexts/CartContext";
import SelecaoVariacoes from "../../components/SelecaoVariacoes";
import { criarEscolhasVariacao, obterErrosVariacoes, valorAdicionalVariacoes } from "../../utils/VariacaoUtils";
import { formatCurrency } from "../../utils/numberUtils";

const PizzaDetails = () => {
  const { groupId } = useParams(); 
  const { fetchData } = useApi();
  const location = useLocation();
  const { pizza } = location.state; 
  const navigate = useNavigate();
  const [sabores, setSabores] = useState([]);
  const [flavorsQuantity, setFlavorsQuantity] = useState(0);
  const [selectedFlavors, setSelectedFlavors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { setCartItemCount, setCartItemTotal } = useCart();
  const [pedidoItemVariacoes, setPedidoItemVariacoes] = useState(() => criarEscolhasVariacao(pizza));
  const [errosVariacao, setErrosVariacao] = useState({});

  const [quantity, setQuantity] = useState(1);
  const [observation, setObservation] = useState(""); // Adicionando o estado para a observação

  useEffect(() => {
    const fetchDataFromAPI = async () => {
      try {    
        const result = await fetchData('/SaborDelivery/SaboresByGrupo', { grupoId: groupId });

        // Ordenar os sabores por tipoSabor
        const sortedSabores = result.sort((a, b) => a.tipoSabor - b.tipoSabor);

        setSabores(sortedSabores);
        setLoading(false);
        setFlavorsQuantity(pizza.qtdeSabor);
      } catch (error) {
        setError("Erro ao buscar sabores: " + error);
        setLoading(false);
      }
    };
    fetchDataFromAPI();
  }, [groupId, pizza.qtdeSabor]);
  

  const handleAddSabor = (sabor) => {
    //console.log(flavorsQuantity);
    
    if (selectedFlavors.length < flavorsQuantity) {
      setSelectedFlavors([...selectedFlavors, sabor]);
    }
  };
  

  const handleRemoveSabor = (sabor) => {
    setSelectedFlavors(selectedFlavors.filter((f) => f.id !== sabor.id));
  };

  const totalPrice = () => {
    const flavorsPrice = selectedFlavors.length * 2;
    return flavorsPrice + valorAdicionalVariacoes(pedidoItemVariacoes) * quantity;
  };

  const addToCart = () => {
    
    const erros = obterErrosVariacoes(pizza, pedidoItemVariacoes);
    setErrosVariacao(erros);
    if (Object.keys(erros).length) return;
    const cart = JSON.parse(localStorage.getItem('cart')) || [];
    cart.push({ ...pizza, qtde:quantity, observacao:observation, selectedFlavors, pedidoItemVariacoes, variacao:null,
      valorItem:Number(pizza.preco || 0) * quantity, valorAdicional:totalPrice(), valorTotal:Number(pizza.preco || 0) * quantity + totalPrice() });
    localStorage.setItem('cart', JSON.stringify(cart));
    const count = cart.reduce((accumulator, item) => accumulator + item.qtde, 0);
    setCartItemCount(count);
    setCartItemTotal(cart.reduce((total, item) => total + Number(item.valorTotal || 0), 0));
    navigate('/cart');
  };

  const cancelAction = () => {
    navigate(-1);
  };

  if (loading) return <p>Carregando...</p>;
  if (error) return <p>Erro: {error}</p>;

  // Agrupar sabores por tipoSaborDesc
  const groupedSabores = sabores.reduce((acc, sabor) => {
    if (!acc[sabor.tipoSaborDesc]) {
      acc[sabor.tipoSaborDesc] = [];
    }
    acc[sabor.tipoSaborDesc].push(sabor);
    return acc;
  }, {});

  const buttonContainerClass = selectedFlavors.length > 0 ? "buttonContainer selected" : "buttonContainer";

  return (
    
    <>
      <Header titulo={pizza.descricao} />
      <MainContent>
        <div className="flavorsSelection">        
          <h3 className="pizzaVariation">{(pizza.produtoVariacoes || []).map(v => v.variacao?.descricao).filter(Boolean).join(' • ')}</h3>
          <SelecaoVariacoes produto={pizza} escolhas={pedidoItemVariacoes} erros={errosVariacao} onChange={escolhas => { setPedidoItemVariacoes(escolhas); setErrosVariacao({}); }} />
          <p>Escolha os sabores:</p>
          {Object.keys(groupedSabores).map(tipoSaborDesc => (
            <div key={tipoSaborDesc}>
                <h2 className={`tipoSaborTitulo ${tipoSaborDesc.toLowerCase()}`}>{tipoSaborDesc}s</h2>
                {groupedSabores[tipoSaborDesc].map(sabor => {
                    const isSelected = selectedFlavors.some((f) => f.id === sabor.id);
                    return (
                        <div key={sabor.id} className={`saborItem ${isSelected ? "selected" : ""}`}>
                            <div className="saborDetails">
                                <h3 className="saborName">{sabor.codSabor} - {sabor.descricao}</h3>
                                <p className="saborIngredientes">{sabor.ingredientes}</p>
                            </div>
                            <div>
                                {isSelected ? (
                                    <>
                                        <button className="qtdeBotao" onClick={() => handleRemoveSabor(sabor)}>-</button>
                                        <span className="qtdeSabor">
                                            {selectedFlavors.filter(f => f.id === sabor.id).length}
                                        </span>
                                        <button className="qtdeBotao" onClick={() => handleAddSabor(sabor)}>+</button>
                                    </>
                                ) : (
                                    <button className="qtdeBotao" onClick={() => handleAddSabor(sabor)}>+</button>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        ))}
        </div>
        <div className="totalPrice">
          <h3>Sabores Selecionados: {selectedFlavors.length}</h3>
          <p>Total: {formatCurrency(Number(pizza.preco || 0) * quantity + totalPrice())}</p>
          <label>Quantidade: <input type="number" min="1" value={quantity} onChange={e => setQuantity(Math.max(1,Number(e.target.value) || 1))} /></label>
        </div>

        <div className="observationContainer">
          <label className="observacaoLabel" htmlFor="observation">Observação:</label>
          <textarea
            id="observation"
            rows="3"
            value={observation}
            onChange={(e) => setObservation(e.target.value)}
            placeholder="Adicione uma observação"
            className="textarea"
          />
        </div>

        <div className={buttonContainerClass} style={{ marginTop: '0px' }}>
          <button className="cancelButton" onClick={cancelAction}>
            <FaTimes /> Cancelar
          </button>
          <button className="addToCartButton" onClick={addToCart}>
            <FaCartPlus /> Adicionar ao Carrinho
          </button>
        </div>
      </MainContent>
      
      <Footer selectedFlavors={selectedFlavors || []} />
    </>
  );
};

export default PizzaDetails;
